import { makeStyles } from '@material-ui/core/styles';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const styles = makeStyles(_theme => ({
  paginationWrapper: {
    justifyContent: 'center',
    width: 'auto',
    margin: '0 auto',
  },
  paginationGridLayout: {
    marginBottom: '-1vh',
  },
  wrapperPosition: {
    position: 'relative',
  },
}));
